<template>
  <div class="clearfix backgroundi" id="login_wrap">
    <div style="display: flex;justify-content: space-between;align-items: center;padding: 50px;">
      <div style="border: 1px solid #000;padding: 5px 10px;border-radius: 10px;background: linear-gradient(to right,rgba(255,255,255),rgba(255,255,255,0));margin: 0 2vw;font-size: 2vw;color: #000;font-weight: 600;">登录/注册</div>
      <div style="border: 1px solid #000;padding: 5px 10px;border-radius: 10px;background: linear-gradient(to right,rgba(255,255,255),rgba(255,255,255,0));margin: 0 2vw;font-size: 2vw;color: #000;font-weight: 600;">视频教学</div>
      <div style="border: 1px solid #000;padding: 5px 10px;border-radius: 10px;background: linear-gradient(to right,rgba(255,255,255),rgba(255,255,255,0));margin: 0 2vw;font-size: 2vw;color: #000;font-weight: 600;">聪哥绿泡泡</div>
      <div style="border: 1px solid #000;padding: 5px 10px;border-radius: 10px;background: linear-gradient(to right,rgba(172,51,193),rgba(255,88,51)); margin: 0 2vw;font-size: 2vw;color: #000;font-weight: 600;">数码博主·合作推广码</div>
    </div>
    <div class="backgroundbox" style="padding-top: 3vw;margin-left: 60vw;">
      <div style="width: 30vw;height: 25vw;margin-top: 15vw;background: #fff;border-radius: 1.5vw 1.5vw 0 0;">
        <div style="display: flex;justify-content: space-between;">
          <div class="logintitle" @click="tourl('https://houtai.08170817.com')">
            <div>代理商登录</div>
            <div style="margin-top: 10px; font-size: 15px;">（如果未注册请先点击下方注册）</div>
          </div>
          <div class="wxlogin">
            <div>厂家登录</div>
            <div style="margin-top: 10px; font-size: 15px;">（如果未注册请先点击下方注册）</div>
          </div>
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;" v-if="logintype==1">
          <div style="margin: 1vw 0; width: 25vw;">
            <el-input v-model="username" placeholder="请您输入厂家登录账号"></el-input>
          </div>
          <div style="margin: 1vw 0;width: 25vw;">
            <el-input v-model="password" placeholder="请您输入厂家登录密码" show-password></el-input>
          </div>
          <div class="loginbtn" @click="login">登录</div>
          <div class="loginbtn" @click="logintypechange(2)"> <el-image style="width: 40px; height: 40px;margin-right: 10px;" src="https://kaifaceshi.08170817.com/static/admin/weixin.png"></el-image>微信扫码登录</div>
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;margin-top: 1.5vw;" v-if="logintype==2">
          <el-image style="width: 10vw; height: 10vw" :src="url" :lazy="true"></el-image>
          <div style="font-size: 1vw;margin-top: 1vw;">微信扫描登录后台</div>
          <div class="loginbtn" @click="logintypechange(1)">账号密码登录</div>
        </div>
        <div style="text-align: center;margin-top: 20px;font-size: 20px;color: #00BAAD;" @click="tourl('https://houtai.08170817.com/#/register')"><span style="color: #383838;">还没有账号？</span>点我立即注册</div>
        <div style="text-align: center;margin-top: 10px;font-size: 20px;color: rgb(212, 47, 47);font-weight: 600;">注册后添加聪哥绿泡泡15555958575 可加速审核</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      logintype:1,
      url:'',
      logincode:"",
      username: "",
      password: "",
    };
  },
  created(e){
    const token = this.$route.query.token;
    if(token){
      // 存储登录信息
      this.setUser({ username: "admin", token: token });
        // 跳转页面
      this.$router.push("/");
    }
  },
  methods: {
    ...mapMutations("login", ["setUser"]),
    async login() {
      let res = await this.$api.login({
        username: this.username,
        password: this.password,
      });

      console.log("登录", res.data);
      if (res.data.code == 200) {
        this.$message({
          message: "登录成功，正在跳转系统首页！",
          type: "success",
          duration: 1000,
        });
        // 存储登录信息
        this.setUser({ username: "admin", token: res.data.data.token });
        // 跳转页面
        setTimeout(() => {
          this.$router.push("/brandnew/brandnewModel");
        }, 1500);
      } else {
        this.$message({
          showClose: true,
          message: "请检查账号错误！",
          type: "error",
        });
      }
    },
    topath(e){
      this.$router.push(e);
    },
    tourl(e){
      window.location.href = e
    },
    async logintypechange(type){
      clearTimeout(this.timerId);
      this.logincode = this.generateRandomString()
      this.logintype = type
      if(type==2){
        let res = await this.$api.getWeChatUrl({logincode:this.logincode})
        if(res.data){
          this.url = res.data
          this.timerId = setInterval(async () => {
              await this.islogin(); // 注意这里的await，确保不会阻塞事件循环
          }, 2000);
        }
      }
    },
    async islogin(){
      let res = await this.$api.islogin({logincode:this.logincode});
      if(res.data.code==200){
        clearTimeout(this.timerId);
        this.$message({
          message: "登录成功，正在跳转系统首页！",
          type: "success",
          duration: 1000,
        });
        // 存储登录信息
        this.setUser({ username: "admin", token: res.data.data.token });
        // 跳转页面
        setTimeout(() => {
          this.$router.push("/");
        }, 1500);
      }
      if(res.data.code==1){
        this.$message({
          message: "当前账号未关联管理员！",
          type: "success",
          duration: 1000,
        });
      }
    },
    generateRandomString(length=12){
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      
      return result;
    }
  },
};
</script>

<style scoped lang="less">
.title {
  text-align: center;
  font-size: 22px;
}

#login_wrap {
  position: relative;
  background: rgba(64, 64, 194, 0.1);
  height: 100%;
}

.info {
  color: #999;
  margin-top: 8px;
  text-align: center !important;
}
.backgroundi {
  background-image: url("https://kaifaceshi.08170817.com/static/admin/loginbg.png") !important;
  /* 设置图片路径 */
  background-size: cover !important;
  /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat !important;
  /* 背景图片不重复 */
  background-position: center !important;
  /* 背景图片居中 */
  width: 100vw;
  /* 元素宽度 */
  height: 25vw;
  /* 元素高度 */
}
.backgroundbox{
  background-image: url("https://kaifaceshi.08170817.com/static/admin/loginbox.png") !important;
  /* 设置图片路径 */
  background-size: cover !important;
  /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat !important;
  /* 背景图片不重复 */
  background-position: center !important;
  /* 背景图片居中 */
  width: 30vw;
  /* 元素宽度 */
  height: 40vw;
  /* 元素高度 */
}
.logintitle{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  height: 3.5vw;
  font-size: 1vw;
  font-weight: 600;
}
.phonelogin{
  display: flex;align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  height: 3.5vw;
  font-size: 1vw;
  font-weight: 600;
  background: linear-gradient(to right,#E2FEC4,#C0FEEC);
  border-radius: 1.5vw 0 5vw 0;
}
.wxlogin{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  height: 3.5vw;
  font-size: 1vw;
  font-weight: 600;
  background: linear-gradient(to right,#E2FEC4,#C0FEEC);
  border-radius: 0 1.5vw 0 5vw;
}
.loginbtn{
  display: flex;
  justify-content: center;
  align-items:center;
  margin: 5px auto;
  background: linear-gradient(to right,#E2FEC4,#C0FEEC);
  width: 15vw;
  height: 3vw;
  border-radius: 0.5vw;
  color: #FFC300;
  font-size: 1.5vw;
  font-weight: 600;
}
/deep/ .el-input__inner{
  height: 3vw;
  font-size: 1vw;
  font-weight: 600;
  background: #EAFFBB;
  border: 0;
  border-radius: 0.75vw;
}
</style>
